import { toPhone } from "common/utils/formatting";
import { parsePhoneInputValue } from "common/utils/phoneParse";

import { InputError, InputStatus } from "./BaseInput";
import TextInput from "./TextInput";

type PhoneInputProps = {
  value: string;
  onChange: (value: string) => void;
  label: string;
  status?: InputStatus;
  includeExtension?: boolean;
  errors?: InputError[];
  disabled?: boolean;
};

const PhoneInput = ({ value, onChange, includeExtension = false, ...rest }: PhoneInputProps) => {
  const formattedPhone = toPhone(value, { includeExtension });
  return (
    <TextInput
      {...rest}
      value={formattedPhone}
      onChange={(newPhone) =>
        onChange(parsePhoneInputValue(formattedPhone, newPhone, { includeExtension }))
      }
      type="tel"
    />
  );
};

export default PhoneInput;
